import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SpinnerComponent } from '../../shared/spinner/spinner.component';
import { DashboardTreeService, WellRedesignReportProject, WellRedesignReportResponse, WellRedesignReportSlurry, WellRedesignReportWell } from '../../services/dashboard-tree.service';

@Component({
  selector: 'app-well-redesign-report',
  imports: [RouterModule, SpinnerComponent],
  templateUrl: './well-redesign-report.component.html',
  styleUrls: ['./well-redesign-report.component.css'],
})
export class WellRedesignReportComponent implements OnInit {
  isLoading = false;
  errorMessage: string | null = null;

  report: WellRedesignReportResponse | null = null;
  selectedWell: WellRedesignReportWell | null = null;

  constructor(
    private route: ActivatedRoute,
    private dashboardTreeService: DashboardTreeService
  ) { }

  ngOnInit(): void {
    const wellIdParam = this.route.snapshot.paramMap.get('wellId');
    const wellId = Number(wellIdParam);

    if (!wellIdParam || Number.isNaN(wellId)) {
      this.errorMessage = 'Invalid well id.';
      return;
    }

    this.loadReport(wellId);
  }

  get wellTitle(): string {
    if (!this.selectedWell) {
      return 'Well Redesigns Report';
    }

    return `${this.selectedWell.wellName} (${this.selectedWell.sbuCode} - ${this.selectedWell.sbuName})`;
  }

  projectDisplayName(project: WellRedesignReportProject): string {
    const projectName = project.projectName?.trim() ?? '';
    const redesignReason = project.redesignReason?.trim() ?? '';

    if (!projectName) {
      return redesignReason || 'Untitled Project';
    }

    return redesignReason ? `${projectName} - ${redesignReason}` : projectName;
  }

  slurryDisplayName(slurry: WellRedesignReportSlurry): string {
    const details: string[] = [];
    const redesignReason = slurry.redesignReason?.trim();

    if (redesignReason) {
      details.push(redesignReason);
    }

    if (slurry.tests && slurry.tests.trim().length > 0) {
      details.push(slurry.tests.trim());
    }

    if (slurry.redesignComments && slurry.redesignComments.trim().length > 0) {
      details.push(slurry.redesignComments.trim());
    }

    return details.length > 0
      ? `${slurry.slurryName} - ${details.join(' | ')}`
      : slurry.slurryName;
  }

  private loadReport(wellId: number): void {
    this.isLoading = true;
    this.errorMessage = null;

    this.dashboardTreeService.getWellRedesignReport(wellId).subscribe({
      next: (response) => {
        this.report = response;
        this.selectedWell = response.wells?.[0] ?? null;

        if (!this.selectedWell) {
          this.errorMessage = 'No redesign report data found for this well.';
        }

        this.isLoading = false;
      },
      error: (err) => {
        console.error('Failed to load well redesign report', err);
        this.errorMessage = 'Failed to load well redesign report.';
        this.isLoading = false;
      },
    });
  }
}
